export enum InquiryStatus {
  UNKNOWN = 0,
  DRAFT = 10,
  OPEN = 20,
  ACCEPTED = 30,
  OPEN_FOR_BIDS = 40,
  WAITING_FOR_ACCEPTANCE = 50,
  ASSIGNED = 60,
  DONE = 70,
  ARCHIVED = 80,
  DELETED = 90,
}
